export const UMB_WORKSPACE_ENTITY_TYPE_CONDITION_ALIAS = 'Umb.Condition.WorkspaceEntityType';
